import "./StoriesProgress.scss";

type StoriesProgressData = {
  completed: string[];
  inProgress: string[];
};

type ApiStory = {
  name: string;
  completionRate: string;
};

export const mapStoriesToProgress = (stories: ApiStory[] = []): StoriesProgressData => {
  const completed: string[] = [];
  const inProgress: string[] = [];

  stories.forEach((story) => {
    const rate = parseFloat(story.completionRate);

    if (rate === 100) {
      completed.push(story.name);
    } else {
      inProgress.push(story.name);
    }
  });

  return { completed, inProgress };
};

const StoriesProgress = ({
  stories,
}: {
  stories?: ApiStory[];
}) => {
  const data = mapStoriesToProgress(stories || []);

  return (
    <div className="stories-progress-card">
      <div className="storytitle">Stories Progress</div>

      <div className="status-header">
        <div className="completed">COMPLETED</div>
        <div className="in-progress">IN PROGRESS</div>
      </div>

      <div className="content">
        <div className="tile">
          {data?.completed?.length === 0 ? (
            <p>No completed stories</p>
          ) : (
            data?.completed?.map((story, index) => <p key={index}>{story}</p>)
          )}
        </div>

        <div className="contentdivider" />

        <div className="tile">
          {data?.inProgress?.length === 0 ? (
            <p>No stories in progress</p>
          ) : (
            data?.inProgress?.map((story, index) => <p key={index}>{story}</p>)
          )}
        </div>
      </div>
    </div>
  );
};

export default StoriesProgress;
